export class RouteUtil {
  //ClientModule Route
  public static readonly CLIENT_MODULE = '';
  public static readonly ACCOUNT_COMPONENT = 'account';
  public static readonly ADDRESS_COMPONENT = 'address';
  public static readonly BASKET_COMPONENT = 'basket';
  public static readonly CHECK_OUT_COMPONENT = 'check-out';
  public static readonly CLIENT_DASHBOARD_COMPONENT = '';
  public static readonly FACILITY_CHOOSER_COMPONENT = '';
  public static readonly FAVORITE_COMPONENT = 'favorite';
  public static readonly MENU_COMPONENT = 'menu';
  public static readonly LANDING_COMPONENT = 'landing';
  public static readonly ORDERS_COMPONENT = 'orders';
  public static readonly PAYMENT_STATUS_COMPONENT = 'payment-status';
  public static readonly PAYMENT_DETAIL_COMPONENT = 'payment-detail';
  public static readonly PROFILE_COMPONENT = 'profile';
  public static readonly SERVICE_DETAILS_PAGE_COMPONENT = 'service-details';
  //End ClientModule Route
  //CommonModule Route
  public static readonly COMMON_MODULE = '';
  public static readonly ABOUT_US_COMPONENT = 'about-us';
  public static readonly LICENCE_AGREEMENT_COMPONENT = 'license-agreement';
  public static readonly SIGN_IN_COMPONENT = 'sign-in';
  //End CommonModule Route
  //DashboardModule Route
  public static readonly DASHBOARD_MODULE = 'dashboard';
  public static readonly HOME_COMPONENT = 'home';
  public static readonly ATTRIBUTE_TYPES_COMPONENT = 'AttributeTypes';
  public static readonly ATTRIBUTES_COMPONENT = 'Attributes';
  public static readonly BUSINESSES_COMPONENT = 'Businesses';
  public static readonly Menu_COMPONENT = 'Menu';
  public static readonly DOMAINS_COMPONENT = 'Domains';
  public static readonly ROLE_PERMISSIONS_COMPONENT = 'RolePermissions';
  public static readonly ROLES_COMPONENT = 'Roles';
  public static readonly STAFFS_COMPONENT = 'Staffs';
  public static readonly CLIENTS_COMPONENT = 'Clients';
  public static readonly DELIVERY_METHODS_COMPONENT = 'DeliveryMethods';
  public static readonly SERVICES_COMPONENT = 'Services';
  public static readonly TAGS_COMPONENT = 'Tags';
  public static readonly ADDITIVES_COMPONENT = 'Additives';
  public static readonly PAYMENT_METHODS_COMPONENT = 'PaymentMethods';
  public static readonly FACTORS_COMPONENT = 'Factors';
  public static readonly ORDERS_ADMIN_COMPONENT = 'Orders';
  public static readonly ADD_OR_UPDATE_SERVICE_COMPONENT = 'AddOrUpdateService';
  public static readonly SPACES_COMPONENT = 'Spaces';
  public static readonly ADD_OR_UPDATE_DOMAIN_COMPONENT = 'AddOrUpdateDomain';
  public static readonly OPEN_FACTORS_COMPONENT = 'OpenFactors';
  public static readonly USER_DETAIL_COMPONENT = 'UserDetails';
  public static readonly PLACE_ORDER_COMPONENT = 'PlaceOrder';
  public static readonly COMMENTS_COMPONENT = 'Comments';
  public static readonly SETTINGS_COMPONENT = 'Settings';
  //End DashboardModule Route
  public static readonly DIALOG_MODULE = 'Dialog';
}
